export default function publicApiBase(location, configuredBase = "") {
  const isLocal = ["localhost", "127.0.0.1", "[::1]", "::1"].includes(location.hostname);
  // A local development API can use a separate port. Deployed examples use the public website origin.
  return (isLocal && configuredBase ? configuredBase : location.origin).replace(/\/$/, "");
}
